import React from 'react';

const TextCategorizationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill={props.color || '#FF8FB1'}
    />
    <path
      opacity="0.5"
      d="M25.4135 10.6236L20.0001 7.50116L9.17334 13.7506V20L25.4135 10.6236Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M14.5864 29.3764L19.9998 32.4988L30.8266 26.2494V20L14.5864 29.3764Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M14.5864 29.3764L19.9998 32.4988L30.8266 26.2494V20L14.5864 29.3764Z"
      fill="white"
    />
    <path
      opacity="0.9"
      d="M14.5864 29.3764L19.9998 32.4988L30.8266 26.2494V20L14.5864 29.3764Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M22.7807 24.6466L14.5867 29.3764L9.17334 26.2494V20L15.9355 16.097V16.97V19.515H17.6445V17.806H19.3535V22.9376H17.6445V24.6466H22.7807Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M22.7807 24.6466L14.5867 29.3764L9.17334 26.2494V20L15.9355 16.097V16.97V19.515H17.6445V17.806H19.3535V22.9376H17.6445V24.6466H22.7807Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M22.7807 24.6466L14.5867 29.3764L9.17334 26.2494V20L15.9355 16.097V16.97V19.515H17.6445V17.806H19.3535V22.9376H17.6445V24.6466H22.7807Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M25.4134 10.6236L15.9399 16.097H20.2125H24.4896V19.515H22.7806V17.806H21.0716V22.9377H22.7806V24.6467L30.8268 20V13.7506L25.4134 10.6236Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M25.4134 10.6236L15.9399 16.097H20.2125H24.4896V19.515H22.7806V17.806H21.0716V22.9377H22.7806V24.6467L30.8268 20V13.7506L25.4134 10.6236Z"
      fill="white"
    />
  </svg>
);

export default TextCategorizationIcon;
